<template>
    <div>
        <input :id="id" :value="value" :listening="fullData"></input>
    </div>
</template>

<script>
    import mobiscroll from '@mobiscroll/javascript'
    import axios from 'axios'
    import _ from 'lodash'

    export default {

        props: {
            edited: {
                type: String,
                default: 0,
                required: true
            },
            value: {
                default: null
            },
            item: {
                type: Object,
                required: true
            },
            fullData: {
                type: Object,
                required: true
            }
        },

        computed: {
            id(){
                return this.item.name
            },
            selectedQuery(){
                if(!!this.item.fieldOptions.dependsOn){
                    return axios.defaults.baseURL  + '/' + this.item.fieldOptions.origin + '/' + this.fullData[this.item.fieldOptions.dependsOn] + '/' 
                } else {
                    return axios.defaults.baseURL + '/' + this.item.fieldOptions.origin + '/'
                }
            }
        },

        methods: {
            loadValues(){
                // axios.post(this.item.fieldOptions.origin, {value: this.value, fullData: this.fullData}).then(r => {
                //     this.inst.option({data: r.data})
                //     this.availableOptions = r.data
                //     this.inst.setVal(this.value)
                // })
            },
            reviewDependants(){
                if(!!this.item.fieldOptions.dependsOn){
                    this.dependsOn = this.item.fieldOptions.dependsOn
                    this.dependingStatus = _.clone(this.fullData[this.dependsOn])
                }
            },
            updateOptions(){
                this.inst.clear()
                this.initialize()
            },
            initialize(){
                this.inst = mobiscroll.select('#' + this.id, {
                    display: 'bubble',
                    disabled: this.item.readonly,
                    filter: true,
                    inputClass: 'form-control',
                    data: {
                        url: this.selectedQuery,
                        remoteFilter: false,
                        type: 'json',
                        processResponse: (response) => {
                            this.availableOptions = response.data
                            return response.data
                        }
                    },
                    onSet:(event, inst) => {
                        this.$emit('input', inst.getVal())
                    }
                })
                this.loadValues()
            }
        },

        data: () => {
            return {
                dependingStatus: null,
                dependsOn: null,
                inst: null,
                availableOptions: []
            }
        },

        watch: {
            edited(){
                if(this.dependingStatus != this.fullData[this.dependsOn]){
                    this.dependingStatus = this.fullData[this.dependsOn]
                    this.updateOptions()
                }
            }
        },

        mounted(){
            this.reviewDependants()
            this.initialize()
        }
    }
</script>